<template>
  <div
    v-if="visible"
    class="popup"
    v-on:click="navigate"
  >
    <div
      class="icon-wrapper"
      :style="iconStyle"
    >
      <img
        alt="cluster"
        src="../assets/cluster.svg"
      />
    </div>
    <CaseCounter
      :name="district.name"
      :name_zh="district.name"
      :district="true"
      :cases="district.center.properties.cases"
      :color="district.center.properties.color"
    />
  </div>

</template>

<script>
import Vue from "vue";
import i18n from "../i18n";
import CaseCounter from "./CaseCounter";

export default Vue.extend({
  i18n: i18n,
  components: { CaseCounter },
  data() {
    return {
      zoom: 10.5,
      zoomThreshold: 10.7
    };
  },
  created() {
    this.map = null;
    this.geocoder = null;
  },
  props: {
    district: {
      required: true,
      type: Object
    },
    highRisk: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    iconStyle() {
      return "background-color: " + this.district.center.properties.color;
    },
    visible() {
      const detailZoom = this.zoom > this.zoomThreshold;
      if (this.highRisk) {
        return detailZoom;
      } else {
        return !detailZoom;
      }
    }
  },
  methods: {
    navigate() {
      const districtName = this.$t("districts." + this.district.name);
      this.geocoder.clear();
      this.geocoder._inputEl.disabled = true;
      this.geocoder.query(districtName);
    }
  }
});
</script>

<style lang="scss" scoped>
.popup {
  position: relative;
  height: 56px;
  background: white;
  // display: flex;
  // flex-direction: row;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
  @include shadow(0, 0, 5px, 0.4);

  .icon-wrapper {
    width: 3vw;
    height: 100%;
    float: left;
    display: inline-block;
    position: relative;
    img {
      position: relative;
      height: 100%;
      width: 70%;
      text-align: center;
      margin: 0 15%;
    }
  }
}
</style>
